/*
  Popup de cupom: gatilho por tempo + intenção de saída (desktop).
  - Mostra no máximo 1x por sessão; fechar silencia por N dias (localStorage);
    inscrito (sucesso do form) nunca mais vê.
  - Exit-intent só com ponteiro fino (desktop); no mobile vale só o timer.
  - Sem JS o popup simplesmente não aparece (fica hidden) — nada quebra.
*/
(() => {
  if (window.__suplNewsletterPopup) return;
  window.__suplNewsletterPopup = true;

  if (window.Shopify && window.Shopify.designMode) return;

  const KEY = 'supl-np';
  const root = document.querySelector('[data-newsletter-popup]');
  if (!root) return;

  const state = (() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  })();
  const save = (patch) => {
    try { localStorage.setItem(KEY, JSON.stringify(Object.assign(state, patch))); } catch (e) {}
  };

  const success = document.documentElement.hasAttribute('data-np-success');
  if (success) {
    save({ subscribed: true });
    // mostra o passo do cupom imediatamente após o cadastro
    root.hidden = false;
    document.documentElement.classList.add('np-open');
    const formStep = root.querySelector('[data-np-step="form"]');
    if (formStep) formStep.hidden = true;
  } else {
    if (state.subscribed) return;
    const suppressDays = parseInt(root.dataset.suppressDays, 10) || 7;
    if (state.closedAt && Date.now() - state.closedAt < suppressDays * 864e5) return;

    let shown = false;
    const open = () => {
      if (shown) return;
      shown = true;
      root.hidden = false;
      document.documentElement.classList.add('np-open');
      const input = root.querySelector('.newsletter-popup__input');
      if (input) input.focus({ preventScroll: true });
    };

    const delay = (parseInt(root.dataset.delay, 10) || 15) * 1000;
    const timer = setTimeout(open, delay);

    // intenção de saída: só desktop (ponteiro fino)
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', function onOut(e) {
        if (e.relatedTarget || e.clientY > 0) return;
        document.removeEventListener('mouseout', onOut);
        clearTimeout(timer);
        open();
      });
    }
  }

  const close = () => {
    root.hidden = true;
    document.documentElement.classList.remove('np-open');
    save({ closedAt: Date.now() });
  };

  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-np-close]')) close();
    const copy = e.target.closest('[data-np-copy]');
    if (copy) {
      const code = copy.dataset.coupon || '';
      const hint = copy.querySelector('[data-np-copy-hint]');
      const done = () => { if (hint) hint.textContent = 'copiado ✓'; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        done();
      }
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !root.hidden) close();
  });
})();
